import {
  Button,
  Card,
  CardContent,
  Chip,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _ from "lodash";
import React from "react";
import { change, Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import { Relationship } from "./objects/Dependants";

const required = value => (value ? undefined : "Required");
const requiredDropdown = value => {
  if (!value || value === "validationError") {
    return "Required";
  }
  return undefined;
};

class Dependants extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }
  
  add = () => {
    let dependants = _.get(
      store.getState().form,
      "newfna.values.dependants",
      {}
    );

    let id = 0;
    if (Object.keys(dependants).length > 0) {
      let max = Math.max.apply(
        Math,
        Object.keys(dependants).map(function(b) {
          return parseInt(b, 10);
        })
      );
      id = max + 1;
    }

    store.dispatch(change("newfna", "dependants." + id, { id: id }));

    this.props.RemoveIgnore(`dependants`);

    this.forceUpdate();
  };

  remove = id => {
    const fieldParent = `dependants`;
    const ignore = RemoveField("newfna", `dependants.${id}`, fieldParent);
    if (ignore) {
      this.props.AddIgnore(fieldParent);
    }

    this.forceUpdate();
  };

  render() {
    let { checkValidation } = this.props;
    const dependants = _.get(
      store.getState().form,
      "newfna.values.dependants",
      {}
    );

    return (
      <div className="contentWithStepper">
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={"Client Name"}
              headline={"Dependants"}
            />
            <Grid container spacing={24} className="customTable1Grid">
              <Table className="customTable1">
                <TableHead className="fixedHead">
                  <TableRow>
                    <TableCell />
                    <TableCell>First Name</TableCell>
                    <TableCell>Surname</TableCell>
                    <TableCell>Gender</TableCell>
                    <TableCell>Date Of Birth</TableCell>
                    <TableCell>Relationship</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ border: "0px" }}>
                      <Chip label="Add" onClick={() => this.add()} />
                    </TableCell>
                  </TableRow>
                  {!dependants
                    ? null
                    : Object.keys(dependants).map((id, i) => {
                        return (
                          <TableRow key={id}>
                            <TableCell>
                              <Button
                                variant="fab"
                                mini
                                className="smallFab"
                                onClick={() => this.remove(id)}
                              >
                                <Icon>remove</Icon>
                              </Button>
                            </TableCell>
                            <TableCell
                              padding="none"
                              className="cellPaddingSmall"
                            >
                              <FormControl fullWidth>
                                <Field
                                  component={FormInput}
                                  isrequired={false}
                                  validate={[required]}
                                  checkValidation={checkValidation}
                                  name={"dependants." + id + ".firstname"}
                                  label="First Name *"
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell
                              padding="none"
                              className="cellPaddingSmall"
                            >
                              <FormControl fullWidth>
                                <Field
                                  component={FormInput}
                                  isrequired={false}
                                  validate={[required]}
                                  checkValidation={checkValidation}
                                  name={"dependants." + id + ".surname"}
                                  label="Surname *"
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell
                              padding="none"
                              className="cellPaddingSmall"
                            >
                              <FormControl fullWidth>
                                <Field
                                  component={FormDropdown}
                                  checkValidation={this.props.checkValidation}
                                  validate={[required]}
                                  isrequired={true}
                                  label="Gender"
                                  name={"dependants." + id + ".gender"}
                                  options={[
                                    {
                                      value: "",
                                      displayValue: "Empty"
                                    },
                                    {
                                      value: "male",
                                      displayValue: "Male"
                                    },
                                    {
                                      value: "female",
                                      displayValue: "Female"
                                    }
                                  ]}
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell
                              padding="none"
                              className="cellPaddingSmall"
                            >
                              <FormControl fullWidth>
                                <Field
                                  component={FormInput}
                                  isrequired={false}
                                  validate={[required, required]}
                                  checkValidation={checkValidation}
                                  name={"dependants." + id + ".dateofbirth"}
                                  label="Date Of Birth *"
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell
                              padding="none"
                              className="cellPaddingSmall"
                            >
                              <FormControl fullWidth>
                                <Field
                                  component={FormDropdown}
                                  checkValidation={this.props.checkValidation}
                                  isrequired={true}
                                  validate={[requiredDropdown]}
                                  label="Relationship"
                                  name={"dependants." + id + ".relationship"}
                                  options={Relationship}
                                />
                              </FormControl>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Dependants;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/Dependants.jsx